const PlanTypes = {
  Custom: 1,
  PayAsYouGo: 2,
  Monthly: 3,
  Preflight: 4,
} as const;
export default PlanTypes;
